export default __webpack_public_path__ + "98dcd24885a76227b49dcfe59adb0616.png";